module.exports = __webpack_public_path__ + "img/heart.68484e23.svg";